<template>
<div class="slide">
  <figure>
    <a class="link" :href="link" v-if="link" target="_blank">
      <icon-arrow class="arrow"></icon-arrow>
    </a>
    <play-button class="play" v-if="video" v-show="!playing"></play-button>
    <video v-if="video" :src="video" @play="playing = true" @pause="playing = false" @ended="playing = false" ref="video" />
    <img v-if="image" :src="image | imgix({ h: 960 })" draggable="false" />
    <figcaption class="size-tiny" v-if="caption" v-html="$options.filters.markdown(caption)"></figcaption>
  </figure>
</div>
</template>

<script>
import Vue from 'vue'
import iconArrow from '!vue-svg-loader!../../static/images/arrow.svg'

export default Vue.component('Slide', {
  props: ['num', 'image', 'video', 'caption', 'link'],
  components: {
    iconArrow
  },
  data: () => ({
    playing: false,
    dragging: false
  }),
  mounted() {
    if(this.$refs.video) {
      const { video } = this.$refs
      this.$parent.$on('static-click', num => {
        if(num === this.num) this.onClickVideo()
      })
      video.addEventListener('touchstart', () => {
        this.dragging = false
      })
      video.addEventListener('touchmove', () => {
        this.dragging = true
      })
      video.addEventListener('touchend', () => {
        if(!this.dragging) {
          if(this.playing) {
            video.pause()
          } else {
            video.play()
          }
        }
        this.dragging = false
      })
    }
  },
  methods: {
    onClickVideo() {
      if(this.playing) {
        this.$refs.video.pause()
      } else {
        this.$refs.video.play()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.slide {
  margin-right: 8rem;
  height: 100%;
  position: relative;
  .link {
    position: absolute;
    top: 0; right: 0;
    width: 2.4rem;
    height: 2.4rem;
    background: $color-red;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.2rem;
    &:hover {
      background: $color-black;
      .arrow /deep/ path {
        stroke: $color-red;
      }
    }
    .arrow {
      margin: 0.4rem;
      width: 100%;
      height: auto;
      transform: rotate(-135deg);
      /deep/ path {
        stroke: $color-white;
      }
    }
  }
  @media (max-width: $break-small) {
    margin-right: $gutter;
  }
  figure {
    display: inline-table;
    &:hover .play {
      transform: translate(-50%, -50%) scale(1.25);
    }
    .play {
      position: absolute;
      top: 50%; left: 50%;
    }
    img, video {
      height: 75vh;
      max-width: none;
      width: auto;
      display: block;
      @media (max-width: $break-small) {
        height: $mobile-gallery-height;
      }
    }
    video {
      cursor: pointer;
      position: absolute;
      top: 0; left: 0;
      bottom: 0; right: 0;
    }
    figcaption {
      display: table-caption;
      caption-side: bottom;
      padding-top: 1.4rem;
      font-family: $font-mono;
      font-weight: normal;
      text-transform: uppercase;
      color: $color-gray;
      max-height: 9.8em;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/slide.vue